import { Audience } from 'lib/types/audience';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchCustomAudiences = async (adAccountId: string): Promise<Audience[]> =>
    privateApiWithRouteLeavingCancelation.get<Audience[]>(`facebook/graph/ad-accounts/${adAccountId}/custom-audiences`);

export const CancelableCustomAudienceGateway = {
    cancelableFetchCustomAudiences,
};
